export const GUEST_ROUTES = {
  HOME: '/',
  NEW_TABLE: '/new',
  JOIN: '/join/:roomID',
  TABLE: '/table',
} as const;

export const joinPath = (roomID: string) =>
  `/join/${encodeURIComponent(roomID)}`;
